"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQaPrLink = void 0;
const qa_1 = require("./qa");
const getQaPrLink = (PR_NUMBER) => {
    return {
        ...qa_1.qaLinks,
        MYPLACE_WEB: `https://myplace-pr-web-${PR_NUMBER !== null && PR_NUMBER !== void 0 ? PR_NUMBER : process.env.PR_NUMBER}.ncc-pgd1.naver.com/my`,
        MYPLACE_API: `https://myplace-pr-api-${PR_NUMBER !== null && PR_NUMBER !== void 0 ? PR_NUMBER : process.env.PR_NUMBER}.ncc-pgd1.naver.com/my`,
        MYPLACE_REVIEW_FEED: `https://myplace-pr-web-${PR_NUMBER !== null && PR_NUMBER !== void 0 ? PR_NUMBER : process.env.PR_NUMBER}.ncc-pgd1.naver.com/my/:userId/reviewfeed?reviewId=:reviewId`,
    };
};
exports.getQaPrLink = getQaPrLink;
